import { render } from "./Tailings.vue?vue&type=template&id=96ed18a0"
import script from "./Tailings.vue?vue&type=script&lang=js"
export * from "./Tailings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__